<p-progress-spinner styleClass="w-8 h-8" strokeWidth="4" animationDuration=".5s"></p-progress-spinner>
